import { render, staticRenderFns } from "./SpaDetails.vue?vue&type=template&id=f33f92f8&scoped=true&"
import script from "./SpaDetails.vue?vue&type=script&lang=js&"
export * from "./SpaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33f92f8",
  null
  
)

export default component.exports